import router, {resetRouter}  from '@router'
import {defaultRoutes} from '@router/routes'
import {getPermissionRoutes} from '@router/permission'
import store from '@store'
import http from '@/axios'
import {dealCancelToken} from '@/axios/cancel'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


NProgress.configure({ showSpinner: false });// NProgress 配置

/**
 * 路由守卫
 */
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  dealCancelToken();
  if (to.path === "/login") {
    resetRouter();// 重置路由
    sessionStorage.clear();// 清除session
    store.commit("clearData");// 清除vuex的值
    next();
  } else if (!store.state.token) {// 未登录或非白名单跳转登录页面
    to?.meta?.allow ? next() : next("/login");
  } else if (!store.state.permissions) {
    let res = {data: {permissions: []}}; // 未获得权限时后台查询并生成对应的路由
    if (res?.data) {
      let permissions = res.data.permissions || [];
      store.commit("setPermission", permissions);
      let permissionRoutes = getPermissionRoutes(permissions);
      router.addRoutes([
        ...permissionRoutes,
        ...defaultRoutes,
      ]);
      next({...to, replace: true});
    }
  } else {
    next();
  }
  NProgress.done();
});
